// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"Embed_loading_container__2s_FJ","loadingContainer":"Embed_loading_container__2s_FJ"};